import { render, staticRenderFns } from "./food.vue?vue&type=template&id=91613df8&scoped=true"
import script from "./food.vue?vue&type=script&lang=js"
export * from "./food.vue?vue&type=script&lang=js"
import style0 from "./food.vue?vue&type=style&index=0&id=91613df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91613df8",
  null
  
)

export default component.exports